import toast from "react-hot-toast"

export const ToastPanel = ({ message }: any) => {
    return (<div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
        <span style={{ marginRight: '8px' }}>⚠️</span>
        {message}
        <button
            onClick={() => toast.dismiss()} // Close the toast when clicked
            style={{
                marginLeft: '8px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                color: 'white',
            }}
        >
            X
        </button>
    </div>)
}